import { useEffect } from 'react';
import Icon from '../AppIcon';

const Toast = ({ message, onClose, duration = 3000, variant = 'success' }) => {
  const isError = variant === 'error';

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 animate-in fade-in slide-in-from-bottom-4">
      <div
        className="flex items-center gap-3 px-6 py-4 rounded-full shadow-lg"
        style={{
          backgroundColor: isError ? '#FEF3C7' : '#2C2B29',
          color: isError ? '#92400E' : '#FFFFFF',
          fontFamily: 'Amiri, serif',
          fontSize: '16px',
          maxWidth: '90vw',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
          border: isError ? '1px solid rgba(245, 158, 11, 0.4)' : 'none'
        }}
      >
        <Icon name={isError ? 'AlertTriangle' : 'CheckCircle'} size={20} color={isError ? '#D97706' : '#C5A059'} />
        <span className="text-center">{message}</span>
      </div>
    </div>
  );
};

export default Toast;